import google from "../../assets/free-google-1772223-1507807.webp";
import {
  Container,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Logo from "../../components/Logo";
import { externalLogin } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../services/user";
import { useGoogleLogin } from "@react-oauth/google";
import LoginForm from "../../components/LoginForm";

const Login = () => {
  const [profile, setProfile] = useState();
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const navigate = useNavigate();

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      externalGoogleLogin(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (!profile) {
      return;
    }
    if (profile.company) {
      navigate("/home-page", {
        state: { profile: profile },
      });
    } else {
      navigate("/form-workspace", {
        state: { profile: profile },
      });
    }
  }, [profile, navigate]);

  const externalGoogleLogin = async (codeResponse) => {
    try {
      setIsGoogleLoading(true);
      const userInfo = {
        companyId: null,
        accessToken: codeResponse.access_token,
      };

      const response = await externalLogin("google", userInfo);

      const userProfile = await getUserById(response.userId);

      setProfile(userProfile);
    } catch (error) {
      //console.error("Error logging in:", error);
      return null;
    }
    setIsGoogleLoading(false);
  };

  return (
    <Container maxWidth="xs" style={{ marginTop: "64px", textAlign: "center" }}>
      <Logo height={100} width={100} style={{ marginBottom: "16px" }} />
      <Typography variant="h4" gutterBottom>
        Iniciar Sesión
      </Typography>
      <LoginForm setProfile={setProfile} />
      <Divider style={{ margin: "16px 0" }} />
      <Typography variant="body2" gutterBottom>
        ¿No tienes una cuenta? <Link to="/register">Regístrate aquí</Link>
      </Typography>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        style={{ marginTop: "8px", backgroundColor: "transparent" }}
        onClick={() => googleLogin()}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {isGoogleLoading ? (
            <CircularProgress />
          ) : (
            <>
              <img
                src={google}
                height={"20px"}
                style={{ marginRight: "8px" }}
                alt="google"
              />
              <span>Continuar con Google</span>
            </>
          )}
        </div>
      </Button>
    </Container>
  );
};

export default Login;
